import { render } from "./GiftIcon.vue?vue&type=template&id=1655a008"
import script from "./GiftIcon.vue?vue&type=script&lang=js"
export * from "./GiftIcon.vue?vue&type=script&lang=js"
script.render = render

export default script